import { useContext } from 'react';
import { PageContext } from '../pageContext';

export const usePageContext = () => {
    const context = useContext(PageContext);

    return context;
};